// Urls
export const STRETCH_FETCH_CLIENT_BY_SHORTNAME = "/client/shortName";
export const GET_LANDING_PAGE_SETTINGS = "/v2/users/:username/page-settings";
export const GET_CLIENT_NETWORK = "/v2/clients/:username/network";

// Constants
export const GET_CLIENT_INFO_DONE = "GET_CLIENT_INFO_DONE";
export const FETCH_CLIENT = "FETCH_CLIENT";
export const FETCH_CLIENT_DONE = "FETCH_CLIENT_DONE";
export const FETCH_CLIENT_ERROR = "FETCH_CLIENT_ERROR";

export const FETCH_GEO_LOCATION = "FETCH_GEO_LOCATION";
export const FETCH_GEO_LOCATION_DONE = "FETCH_GEO_LOCATION_DONE";
export const FETCH_GEO_LOCATION_ERROR = "FETCH_GEO_LOCATION_ERROR";

export const FETCH_CLIENT_BRANDING = "FETCH_CLIENT_BRANDING";
export const FETCH_CLIENT_BRANDING_DONE = "FETCH_CLIENT_BRANDING_DONE";
export const FETCH_CLIENT_BRANDING_ERROR = "FETCH_CLIENT_BRANDING_ERROR";

export const FETCH_CLIENT_NETWORK = "FETCH_CLIENT_NETWORK";
export const FETCH_CLIENT_NETWORK_DONE = "FETCH_CLIENT_NETWORK_DONE";
export const FETCH_CLIENT_NETWORK_ERROR = "FETCH_CLIENT_NETWORK_ERROR";

export const LOCATION_ALLOW_BLOCK = "LOCATION_ALLOW_BLOCK";
